import React from "react";
import { Modal } from "react-bootstrap";
import ChangeLoginInfoForm from "../../../Home/Forms/ChangeLoginInfoForm";

const ChangeLoginInfoModal = ({ show, onClose, user, onSubmit, t }) => {
    if (!show || !user) return null;

    return (
        <Modal size="md" centered backdrop="static" keyboard={false} show={show} onHide={onClose}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <div className="h5 mb-0">
                        <i className="fad fa-fingerprint text-success icon ml-2"></i>
                        {t("Pages.UsersControl.action.changeLoginInfo")}:
                        <span className="text-primary mr-1">{user.Name}</span>
                    </div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="widget widget-category">
                    <div className="widget-body">
                        <ChangeLoginInfoForm onSubmit={onSubmit} user={user} />
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ChangeLoginInfoModal;
